<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('user.withdraw.realMoney')" prop="realMoney" >
        <a-input disabled v-model="form.realMoney"></a-input>
      </a-form-model-item>

      <a-form-model-item :label="$t('user.withdraw.withdrawType')" prop="withdrawType" >
        <a-select v-model="form.withdrawType" disabled :placeholder="$t('system.selectPlaceholder')">
          <a-select-option :key="1">{{ $t('user.withdraw.paypal') }}</a-select-option>
          <a-select-option :key="2">{{ $t('user.withdraw.bankCard') }}</a-select-option>
          <a-select-option :key="3">{{ $t('user.withdraw.alipay') }}</a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item :label="$t('user.withdraw.securityCode')" prop="paypalMobile" v-if="form.withdrawType == 1">
        <a-input disabled v-model="form.paypalRealName"></a-input>
      </a-form-model-item>

      <a-form-model-item :label="$t('user.withdraw.cardNumber')" prop="paypalMobile" v-if="form.withdrawType == 1">
        <a-input disabled v-model="form.paypalMobile"></a-input>
      </a-form-model-item>


      <a-form-model-item :label="$t('user.withdraw.cardholderName')" prop="bankRealName" v-if="form.withdrawType == 2">
        <a-input disabled v-model="form.bankRealName"></a-input>
      </a-form-model-item>

      <a-form-model-item :label="$t('user.withdraw.bankName')" prop="bankName" v-if="form.withdrawType == 2">
        <a-input disabled v-model="form.bankName"></a-input>
      </a-form-model-item>

      <a-form-model-item :label="$t('user.withdraw.bankCardNumber')" prop="bankNo" v-if="form.withdrawType == 2">
        <a-input disabled v-model="form.bankNo"></a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('user.withdraw.bankAccount')" prop="bankAccount" v-if="form.withdrawType == 2">
        <a-input disabled v-model="form.bankAccount"></a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('user.withdraw.alipayQRCode')" prop="alipayMobile" v-if="form.withdrawType == 3">
        <div v-if="form.alipayMobile" style="width: 100%">
          <img
            :src="form.alipayMobile"
            :alt="$t('user.withdraw.alipayQRCode')"
            style="max-width: 260px; max-height: 260px; border: 1px solid #f0f0f0; border-radius: 4px;"
          />
        </div>
        <span v-else>{{ $t('user.withdraw.noQRCode') }}</span>
      </a-form-model-item>

      <a-form-model-item :label="$t('user.withdraw.realName')" prop="alipayName" v-if="form.withdrawType == 3">
        <a-input disabled v-model="form.alipayName"></a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('system.status')" prop="status" >
        <a-select v-model="form.status" :placeholder="$t('system.selectPlaceholder')">
          <a-select-option v-if="auditStatusBoonbean" :key="1">{{ $t('user.withdraw.rejected') }}</a-select-option>
          <a-select-option v-if="auditStatusBoonbean" :key="2">{{ $t('user.withdraw.approved') }}</a-select-option>
          <a-select-option v-if="!auditStatusBoonbean" :key="3">{{ $t('user.withdraw.paid') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('user.withdraw.auditOpinion')" prop="auditOpinion" >
        <a-textarea :row="3" v-model="form.auditOpinion" :placeholder="$t('user.withdraw.inputAuditOpinion')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdraw, addWithdraw, updateWithdraw } from '@/api/user/withdraw'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        money: null,

        realMoney: null,

        serviceChargeNum: null,

        status: 0,

        withdrawType: null,

        withdrawUserType: null,

        orderNo: null,

        failureReason: null,

        auditOpinion: null,

        cateName: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        userId: [
          { required: true, message: this.$t('user.withdraw.userIdRequired'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('user.withdraw.moneyRequired'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('user.withdraw.statusRequired'), trigger: 'blur' }
        ],
        withdrawType: [
          { required: true, message: this.$t('user.withdraw.withdrawTypeRequired'), trigger: 'change' }
        ],
        withdrawUserType: [
          { required: true, message: this.$t('user.withdraw.withdrawUserTypeRequired'), trigger: 'change' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        money: null,
        realMoney: null,
        serviceChargeNum: null,
        status: 0,
        withdrawType: null,
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        cateName: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdraw({"id":id}).then(response => {
        this.form = response.data;
        this.formTitle = this.$t('user.withdraw.audit')
        if(this.form.status == 0) {
          this.form.status = 2;
          this.auditStatusBoonbean = true;
        } else if(this.form.status == 2) {
          this.form.status = 3;
          this.auditStatusBoonbean = false;
        }
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateWithdraw(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addWithdraw(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
